import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface PhaseStatusIndicatorProps {
  status: 'not_started' | 'in_progress' | 'completed' | 'failed' | 'skipped' | string;
  showLabel?: boolean;
}

export const PhaseStatusIndicator: React.FC<PhaseStatusIndicatorProps> = ({
  status,
  showLabel = true
}) => {
  const { darkMode } = useTheme();
  
  // Get status color
  const getStatusColor = () => {
    // Normalize status to handle any string value
    const normalizedStatus = status?.toLowerCase() || 'not_started';
    
    if (darkMode) {
      switch(normalizedStatus) {
        case 'in_progress': return 'bg-blue-500';
        case 'completed': return 'bg-green-500';
        case 'failed': return 'bg-red-500';
        case 'skipped': return 'bg-yellow-500';
        case 'not_started': return 'bg-gray-500';
        default: return 'bg-gray-500';
      }
    } else {
      switch(normalizedStatus) {
        case 'in_progress': return 'bg-blue-500';
        case 'completed': return 'bg-green-500';
        case 'failed': return 'bg-red-500';
        case 'skipped': return 'bg-yellow-500';
        case 'not_started': return 'bg-gray-400';
        default: return 'bg-gray-400';
      }
    }
  };
  
  // Get status label
  const getStatusLabel = () => {
    // Normalize status to handle any string value
    const normalizedStatus = status?.toLowerCase() || 'not_started';
    
    switch(normalizedStatus) {
      case 'in_progress': return 'In Progress';
      case 'completed': return 'Completed';
      case 'failed': return 'Failed';
      case 'skipped': return 'Skipped';
      case 'not_started': return 'Not Started';
      default: return normalizedStatus ? (normalizedStatus.charAt(0).toUpperCase() + normalizedStatus.slice(1)) : 'Not Started';
    }
  };
  
  return (
    <div className="flex items-center">
      <div className={`w-3 h-3 rounded-full ${getStatusColor()}`}></div>
      {showLabel && (
        <span className={`ml-2 text-sm ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
          {getStatusLabel()}
        </span>
      )}
    </div>
  );
};
